import { token } from '@atlaskit/tokens';
import React from 'react';
import Spinner from '@atlaskit/spinner';
import { environment, envs } from '../../services/environment';
import { css } from '@compiled/react';

const myAtlassianRedirectStyles = css({
  margin: `${token('space.300')} 0`,
});

export function MyAtlassianRedirect() {
  if (environment().name === envs.PROD) {
    window.location.href = 'https://id.atlassian.com/manage-profile/email';
  } else {
    window.location.href = 'https://id.stg.internal.atlassian.com/manage-profile/email';
  }
  return (
    <div css={myAtlassianRedirectStyles}>
      Please wait... <Spinner />
    </div>
  );
}
